
























import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, VModel } from 'vue-property-decorator'

import HelpMessage from '../../../../HelpMessage/HelpMessage.vue'
import { ConditionType } from '../../types'

@Component({
  components: {
    HelpMessage
  }
})
export default class ConditionsListModal extends Vue {
  @VModel() isVisible!:boolean

  titleTranslationKey(type: ConditionType) {
    return `field_distribution_condition_${ snakeCase(type) }_title`
  }

  helpMessageTranslationKey(type: ConditionType) {
    return `field_distribution_condition_${ snakeCase(type) }_help_message`
  }

  @Emit()
  selectType(type: ConditionType) {
    return type
  }

  conditions = [
    {
      type: ConditionType.Sent,
      title: this.titleTranslationKey(ConditionType.Sent),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Sent)
    },
    {
      type: ConditionType.Activity,
      title: this.titleTranslationKey(ConditionType.Activity),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Activity)
    },
    {
      type: ConditionType.Utm,
      title: this.titleTranslationKey(ConditionType.Utm),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Utm)
    },
    {
      type: ConditionType.Labels,
      title: this.titleTranslationKey(ConditionType.Labels),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Labels)
    },
    {
      type: ConditionType.Users,
      title: this.titleTranslationKey(ConditionType.Users),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Users)
    },
    {
      type: ConditionType.Boosts,
      title: this.titleTranslationKey(ConditionType.Boosts),
      helpMessage: this.helpMessageTranslationKey(ConditionType.Boosts)
    }
  ]
}
